import type { TaskMarker as TaskMarkerName } from './projectData'

type MarkerGlyphProps = {
  marker: TaskMarkerName
  size: number
  fill: string
  stroke?: string
  strokeWidth?: number
  className?: string
}

export function MarkerGlyph({ marker, size, fill, stroke = 'none', strokeWidth = 0, className }: MarkerGlyphProps) {
  const half = size / 2
  const common = { fill, stroke, strokeWidth, className }

  if (marker === 'circle') return <circle {...common} cx="0" cy="0" r={half} />
  if (marker === 'square') return <rect {...common} x={-half} y={-half} width={size} height={size} />
  if (marker === 'triangle-up') return <polygon {...common} points={`0,${-half} ${half},${half} ${-half},${half}`} />
  if (marker === 'triangle-down') return <polygon {...common} points={`${-half},${-half} ${half},${-half} 0,${half}`} />
  if (marker === 'diamond') return <polygon {...common} points={`0,${-half} ${half},0 0,${half} ${-half},0`} />

  const arm = size * 0.22
  return (
    <path
      {...common}
      d={`M ${-arm} ${-half} H ${arm} V ${-arm} H ${half} V ${arm} H ${arm} V ${half} H ${-arm} V ${arm} H ${-half} V ${-arm} H ${-arm} Z`}
    />
  )
}

export function TaskMarkerIcon({ marker, colour, label }: { marker: TaskMarkerName; colour: string; label?: string }) {
  return (
    <svg className="task-marker-icon" viewBox="-8 -8 16 16" role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <MarkerGlyph marker={marker} size={11} fill={colour} stroke="#20211d" strokeWidth={1.2} />
    </svg>
  )
}
